import UserPreferences from '@/creditflowresearch/ui/common/components/organisms/UserPreferences';
import UserProfileMenuTemplate from './UserProfileMenuTemplate';

interface IUserProfileMenuTemplateDesktopProps {
  onClose?: () => void,
}

const UserProfileMenuTemplateDesktop = ({ onClose }: IUserProfileMenuTemplateDesktopProps) => {
  return (
    <UserProfileMenuTemplate onClose={ onClose }>
      <UserPreferences />
    </UserProfileMenuTemplate>
  );
};

export default UserProfileMenuTemplateDesktop;
